import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { serviceService } from "../../services/serviceService";

export const fetchServices = createAsyncThunk(
  "services/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const res = await serviceService.list(params);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Hizmetler yüklenemedi");
    }
  }
);

export const createService = createAsyncThunk(
  "services/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await serviceService.create(payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Hizmet eklenemedi");
    }
  }
);

export const updateService = createAsyncThunk(
  "services/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await serviceService.update(id, payload);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Hizmet güncellenemedi");
    }
  }
);

export const hardDeleteService = createAsyncThunk(
  "services/hardDelete",
  async (id, { rejectWithValue }) => {
    try {
      await serviceService.hardRemove(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Hizmet silinemedi");
    }
  }
);

export const setServiceActive = createAsyncThunk(
  "services/setActive",
  async ({ id, active }, { rejectWithValue }) => {
    try {
      const res = await serviceService.setActive(id, active);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Durum değiştirilemedi");
    }
  }
);

const upsert = (state, updated) => {
  const i = state.items.findIndex((s) => s.id === updated.id);
  if (i !== -1) state.items[i] = { ...state.items[i], ...updated };
};

const serviceSlice = createSlice({
  name: "services",
  initialState: { items: [], isLoading: false, error: null },
  reducers: {
    clearServiceError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServices.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload.content ?? [];
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })
      .addCase(updateService.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(setServiceActive.fulfilled, (state, action) => upsert(state, action.payload))
      .addCase(hardDeleteService.fulfilled, (state, action) => {
        state.items = state.items.filter((s) => s.id !== action.payload);
      });
  },
});

export const { clearServiceError } = serviceSlice.actions;
export default serviceSlice.reducer;
